import { useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";
import { renderQuickLinkIcon } from "../../../utils/quickLinkIcons";

import "../../../styles/pages/homePage/ouLinks.scss";

const OuLinks = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { response, fetchData } = useAxios();

  useEffect(() => {
    fetchData({ url: "/quick-links", method: "GET" }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const links = response || [];
  const filteredSystems = links.filter(
    (system) =>
      system.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      system.short_description
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  return (
    <div className="internal-systems">
      <div className="section-header">
        <input
          type="text"
          placeholder="Search UPOU Systems..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="quick-links">
        {filteredSystems.map((system) => (
          <a
            key={system.id}
            href={system.link}
            className="quick-link-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="icon-container">
              {renderQuickLinkIcon(system.icon)}
            </div>
            <div className="link-content">
              {system.is_pinned && (
                <span className="most-used-badge">★ Most Used</span>
              )}
              <span className="title">{system.title}</span>
              <span className="description">{system.short_description}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default OuLinks;
